'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getCurrentStepKey = exports.getCurrentStepKey = function getCurrentStepKey(state) {
  return state.currentStep && state.currentStep.get('key');
};

var getCurrentAppStepNumber = exports.getCurrentAppStepNumber = function getCurrentAppStepNumber(state) {
  return state.currentStep && state.currentStep.get('number');
};
var getCurrentStepTrackingNumber = exports.getCurrentStepTrackingNumber = function getCurrentStepTrackingNumber(state) {
  return state.currentStep && getCurrentAppStepNumber(state) + 1;
};

var getTotalSteps = exports.getTotalSteps = function getTotalSteps(state) {
  return state.currentStep && state.currentStep.get('totalSteps');
};